import {
  Button,
  Container,
  Paper,
  TextField, IconButton, InputAdornment,
  Typography
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import React, { ForwardedRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

import ServiceAPI from '../../services/serviceapi';
import { FormatUtils } from '../../utils/formatutils';
import { PatternUtils } from '../../utils/patterutils';
import { SecUtils } from '../../utils/secutils';

interface CadastroData {
  nome?: string;
  email?: string;
  url?: string;
  cpfCnpj?: string;
  celular?: string;
  cep?: string;
}

const Cadastro = React.forwardRef((_props: unknown, _ref: ForwardedRef<any>) => {
  const navigate = useNavigate();
  const [cadastro, setCadastro] = useState<CadastroData>({ url: '' });
  const [showPassword, setShowPassword] = useState(false);

  const botaoDesativado = (): boolean => {
    return !cadastro.nome || !cadastro.email || !cadastro.url || !cadastro.cpfCnpj;
  };

  const cadastrar = async () => {
    try {

      const result = await ServiceAPI.consumeService({
        url: '/public/cadastro/cliente',
        data: cadastro,
        config: { ignoreToast: false }
      });

      if (result.codeResponse === 'SUCESSO_PERSISTENCIA') {
        toast.success('Sucesso, confira seu e-mail para acessar a página de administração!');
        navigate(`/confirmacaocadastro`);
      }
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Falha ao tentar persistir');
      }
    }
  };

  const onChangeUrl = (value: string) => {
    const cleanValue = value.replace(/[^A-Za-z0-9]/g, '').toLowerCase().trim();
    setCadastro({ ...cadastro, url: cleanValue });
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Paper elevation={3} sx={{ padding: 4, textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h5" gutterBottom>
          Olá, Vamos Começar!
        </Typography>

        <TextField
          label="Digite seu Nome"
          placeholder="Nome Completo"
          value={cadastro.nome || ''}
          onChange={(e) => setCadastro({ ...cadastro, nome: e.target.value })}
          fullWidth
          required
        />

        <TextField
          label="Informe o CPF ou CNPJ do Titular"
          placeholder="000.000.000-00"
          value={cadastro.cpfCnpj || ''}
          onChange={(e) => setCadastro({ ...cadastro, "cpfCnpj": FormatUtils.formatarCpfCnpj(e.target.value) })}
          fullWidth
          required
        />

        <TextField
          label="Informe seu WhatsApp"
          placeholder="(00) 00000-0000"
          value={cadastro.celular || ''}
          onChange={(e) => setCadastro({ ...cadastro, celular: FormatUtils.formatarNumeroCelular(e.target.value) })}
          fullWidth
          inputProps={{ maxLength: 15, pattern: PatternUtils.celular }}
        />

        <TextField
          label="Email"
          placeholder="@"
          type="email"
          value={cadastro.email || ''}
          onChange={(e) => setCadastro({ ...cadastro, email: e.target.value })}
          fullWidth
          required
        />

        <TextField
          label="Empresa ID (sem espaços)"
          placeholder={`felicidadesecosemolhados"`}
          value={cadastro.url || ''}
          onChange={(e) => onChangeUrl(e.target.value)}
          fullWidth
          inputProps={{ maxLength: 50 }}
          required
        />

        <TextField
          label="CEP"
          placeholder="00000-000"
          value={cadastro.cep || ''}
          onChange={(e) => setCadastro({ ...cadastro, cep: FormatUtils.formatarCEP(e.target.value) })}
          fullWidth
        />

        <Button
          sx={{
            borderColor: 'black',
            color: 'black',
            '&:hover': {
              borderColor: 'black',
              backgroundColor: 'transparent'
            },
            mt: 2
          }}
          variant="outlined"
          disabled={botaoDesativado()}
          onClick={cadastrar}
          fullWidth
        >
          Próximo
        </Button>
      </Paper>
    </Container>
  );
});

export default Cadastro;
